export const memberList = [
  {
    id: 501,
    label: 'Johnson',
    value: 501,
    image: '/assets/images/avatar/A23.jpg',
  },
  {
    id: 502,
    label: 'Joe Root',
    value: 502,
    image: '/assets/images/avatar/A24.jpg',
  },
  {
    id: 503,
    label: 'Monty Panesar',
    value: 503,
    image: '/assets/images/avatar/A25.jpg',
  },
  {
    id: 504,
    label: 'Darren Gough',
    value: 504,
    image: '/assets/images/avatar/A26.jpg',
  },
  {
    id: 505,
    label: 'Andy Caddick',
    value: 505,
    image: '/assets/images/avatar/A27.jpg',
  },
  {
    id: 506,
    label: 'Marcus Vaughan',
    value: 506,
    image: '/assets/images/avatar/A28.jpg',
  },
];
